import React from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {CountryService} from '../../../services';
import CustomDataGrid from '../../../customUtil/DataGrid';
const columns = [
    {
        field: 'countryCode', headerName: 'Code', width: 130,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/references/country/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'countryName', headerName: 'Country', width: 230},
    {field: 'hasRegistration', headerName: 'Has Registration', width: 130},
    {field: 'hasPreinspection', headerName: 'Has Pre-inspection', width: 130},
    {field: 'hasAdditionalDocumentRequirements', headerName: 'Additional Info on Documents', width: 130},
    {field: 'hasWaiver', headerName: 'For Waiver', width: 130}
]

const Countries = () => {
        const [list, setList] = React.useState([]);
        const history = useHistory();

        React.useEffect(() => {
            CountryService.getAll()
                .then((response) => setList(response.data));
        }, []);

        return (
            <div>
                <Container>
                    <header>
                        <h1>Countries</h1>
                    </header>
                    <Grid container spacing={5}>                      
                        <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/references/country/new')}}>Create New</Button>
                        </Grid> 
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                components={false}
                               />
                          
                        </Grid>
                    </Grid>
                </Container>
            </div>
        );
    }
;

export default Countries;
